module.exports = {
    Glow: require('./glow'),
    Glitch: {
        Convergence: require('./glitch/convergence'),
        CutSlider: require('./glitch/cutslider'),
        Glow: require('./glitch/glow'),
        Noise: require('./glitch/noise'),
        Outline: require('./glitch/outline'),
        Shaker: require('./glitch/shaker'),
        SlitScan: require('./glitch/slitscan'),
        Swell: require('./glitch/swell'),
        Twist: require('./glitch/twist')
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/filters/index.js
 ** module id = 9
 ** module chunks = 0
 **/